import React from 'react'
import withIcon from '@/components/withIcon'

const IconSwim = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4209_133195)">
        <path
          d="M23.4862 17.718C20.9862 18.239 19.4262 15.739 19.4262 15.739C19.0394 16.3557 18.5057 16.8667 17.8729 17.2264C17.2401 17.5861 16.5279 17.7832 15.8002 17.8C15.0783 17.7645 14.3748 17.56 13.7464 17.2028C13.1179 16.8457 12.5822 16.346 12.1822 15.744C11.7951 16.3586 11.262 16.8679 10.6304 17.2266C9.99881 17.5854 9.28832 17.7823 8.56219 17.8C7.8405 17.7653 7.13713 17.5611 6.50908 17.2039C5.88102 16.8467 5.34594 16.3465 4.94719 15.744C4.94719 15.744 2.94719 18.286 0.492188 17.764L0.518187 23.282H23.5182L23.4862 17.718Z"
          fill="#C6D5D8"
        />
        <path
          d="M23.4862 21.718C20.9862 22.239 19.4262 19.739 19.4262 19.739C19.0394 20.3557 18.5057 20.8667 17.8729 21.2264C17.2401 21.5861 16.5279 21.7832 15.8002 21.8C15.0786 21.7647 14.3755 21.5603 13.7475 21.2031C13.1195 20.846 12.5844 20.3462 12.1852 19.744C11.7981 20.3593 11.2646 20.8692 10.6324 21.2279C10.0002 21.5867 9.28893 21.7833 8.56219 21.8C7.8405 21.7653 7.13713 21.5611 6.50908 21.2039C5.88102 20.8467 5.34594 20.3465 4.94719 19.744V19.744C4.94719 19.744 2.94719 22.286 0.492188 21.764"
          stroke="#00303E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.4862 17.718C20.9862 18.239 19.4262 15.739 19.4262 15.739C19.0394 16.3557 18.5057 16.8667 17.8729 17.2264C17.2401 17.5861 16.5279 17.7832 15.8002 17.8C15.0786 17.7647 14.3755 17.5603 13.7475 17.2031C13.1195 16.846 12.5844 16.3462 12.1852 15.744V15.744C11.7981 16.3593 11.2646 16.8692 10.6324 17.2279C10.0002 17.5867 9.28893 17.7833 8.56219 17.8C7.8405 17.7653 7.13713 17.5611 6.50908 17.2039C5.88102 16.8467 5.34594 16.3465 4.94719 15.744V15.744C4.94719 15.744 2.94719 18.286 0.492188 17.764"
          stroke="#00303E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.98535 14.9999V3.2229C8.98535 2.55986 9.24874 1.92397 9.71758 1.45513C10.1864 0.986293 10.8223 0.7229 11.4854 0.7229C12.1484 0.7229 12.7843 0.986293 13.2531 1.45513C13.722 1.92397 13.9854 2.55986 13.9854 3.2229V4.2229"
          stroke="#00303E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9863 15.2179V3.2229C15.9863 2.55986 16.2497 1.92397 16.7186 1.45513C17.1874 0.986293 17.8233 0.7229 18.4863 0.7229C19.1494 0.7229 19.7853 0.986293 20.2541 1.45513C20.7229 1.92397 20.9863 2.55986 20.9863 3.2229V4.2229"
          stroke="#00303E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.98535 9.7229H15.9854"
          stroke="#00303E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.98535 6.7229H15.9854"
          stroke="#00303E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.98535 12.7229H15.9854"
          stroke="#00303E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4209_133195">
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default withIcon(IconSwim)
